<template>
  <b-card no-body>
    <div class="m-2">
      <!-- Upload Section -->
      <b-card class="mb-3" title="Thêm chiến dịch ZNS mới">
        <b-row>
          <b-col cols="12" md="3">
            <b-form-group label="Tên chiến dịch">
              <b-form-input v-model="form.campaignName" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group label="Chọn Template ZNS">
              <b-form-select v-model="form.templateId" :options="templateOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2" class="d-flex align-items-end mb-3">
            <b-button variant="outline-success" @click="downloadSample" :disabled="!form.templateId">Tải file mẫu</b-button>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Chọn File Excel">
              <b-form-file v-model="form.file" accept=".xlsx, .xls" placeholder="Chọn file..." drop-placeholder="Kéo thả file vào đây..."></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button variant="primary" @click="uploadCampaign" :disabled="!form.file || !form.templateId || !form.campaignName">Upload Chiến Dịch</b-button>
          </b-col>
        </b-row>
      </b-card>

      <hr/>

      <!-- List Campaigns -->
      <b-row class="mb-2">
        <b-col cols="12" md="6">
          <h4>Danh sách Chiến dịch</h4>
        </b-col>
        <b-col cols="12" md="6">
          <b-input-group>
            <b-form-input v-model="searchQuery" placeholder="Tìm kiếm tên chiến dịch..."></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-primary" @click="loadCampaigns">Tìm</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table hover :items="campaigns" :fields="fields" show-empty empty-text="Không có dữ liệu">
        <template #cell(STATUS)="data">
          <b-badge :variant="statusColor(data.value)">
            {{ statusText(data.value) }}
          </b-badge>
        </template>
        <template #cell(progress)="data">
           <b-progress :max="data.item.TOTAL_RECORDS" class="mt-1">
              <b-progress-bar :value="data.item.SUCCESS_RECORDS" variant="success"></b-progress-bar>
              <b-progress-bar :value="data.item.FAIL_RECORDS" variant="danger"></b-progress-bar>
           </b-progress>
           <small class="text-muted">{{ (data.item.SUCCESS_RECORDS + data.item.FAIL_RECORDS) }} / {{ data.item.TOTAL_RECORDS }}</small>
        </template>
        <template #cell(actions)="data">
          <b-button size="sm" variant="info" @click="viewDetail(data.item.ID)">Xem chi tiết</b-button>
        </template>
      </b-table>
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @change="pageChanged"></b-pagination>
    </div>

    <!-- Modal Detail -->
    <b-modal v-model="showDetailModal" title="Chi tiết chiến dịch" size="xl" hide-footer>
       <b-table hover :items="details" :fields="detailFields" show-empty empty-text="Không có dữ liệu">
         <template #cell(STATUS)="data">
            <b-badge :variant="detailStatusColor(data.value)">
              {{ detailStatusText(data.value) }}
            </b-badge>
          </template>
       </b-table>
       <b-pagination v-model="detailPage" :total-rows="detailTotalRows" :per-page="detailPerPage" @change="detailPageChanged"></b-pagination>
    </b-modal>

  </b-card>
</template>

<script>
import axios from 'axios'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormSelect, BFormFile, BButton,
  BInputGroup, BInputGroupAppend, BTable, BBadge, BProgress, BProgressBar,
  BPagination, BModal
} from 'bootstrap-vue'

export default {
  name: 'ZnsCampaign',
  components: {
    BCard, BRow, BCol, BFormGroup, BFormInput, BFormSelect, BFormFile, BButton,
    BInputGroup, BInputGroupAppend, BTable, BBadge, BProgress, BProgressBar,
    BPagination, BModal
  },
  data() {
    return {
      templateList: [],
      form: {
        campaignName: '',
        templateId: null,
        file: null
      },
      campaigns: [],
      fields: [
        { key: 'ID', label: 'ID' },
        { key: 'CAMPAIGN_NAME', label: 'Tên chiến dịch' },
        { key: 'TEMPLATE_NAME', label: 'Template' },
        { key: 'FILE_NAME', label: 'File Name' },
        { key: 'STATUS', label: 'Trạng thái' },
        { key: 'progress', label: 'Tiến độ' },
        { key: 'CREATED_AT', label: 'Ngày tạo' },
        { key: 'actions', label: 'Chi tiết' }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      searchQuery: '',
      
      // Detail
      showDetailModal: false,
      selectedCampaignId: null,
      details: [],
      detailFields: [
        { key: 'ID', label: 'ID' },
        { key: 'PHONE_NUMBER', label: 'Số thuê bao' },
        { key: 'PARAMS_DATA', label: 'Dữ liệu' },
        { key: 'STATUS', label: 'Trạng thái' },
        { key: 'RESPONSE_MESSAGE', label: 'Phản hồi' },
      ],
      detailPage: 1,
      detailPerPage: 10,
      detailTotalRows: 0
    }
  },
  computed: {
    templateOptions() {
      let opts = [{ value: null, text: '--- Chọn template ---' }]
      this.templateList.forEach(t => {
        opts.push({ value: t.ID, text: `${t.TEMPLATE_ID} - ${t.TEMPLATE_NAME}` })
      })
      return opts
    }
  },
  mounted() {
    this.loadTemplates()
    this.loadCampaigns()
  },
  methods: {
    loadTemplates() {
      axios.get('/api/tool/zns-template/active-list').then(res => {
        this.templateList = res.data;
      })
    },
    loadCampaigns() {
      axios.get(`/api/tool/zns-campaign/list?page=${this.currentPage}&limit=${this.perPage}&keyword=${this.searchQuery}`).then(res => {
        this.campaigns = res.data.data;
        this.totalRows = res.data.total;
      })
    },
    pageChanged(page) {
      this.currentPage = page;
      this.loadCampaigns();
    },
    downloadSample() {
      if (!this.form.templateId) return;
      window.location.href = `/api/tool/zns-campaign/download-sample?templateId=${this.form.templateId}`
    },
    uploadCampaign() {
      let formData = new FormData();
      formData.append('file', this.form.file);
      formData.append('campaignName', this.form.campaignName);
      formData.append('templateId', this.form.templateId);
      
      axios.post('/api/tool/zns-campaign/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data.status === 'error') {
          alert("Lỗi: " + res.data.message);
        } else {
          alert("Upload thành công");
          this.form = { campaignName: '', templateId: null, file: null };
          this.loadCampaigns();
        }
      }).catch(err => {
        alert("Có lỗi xảy ra: " + err);
      })
    },
    statusText(status) {
      if (status == 0) return 'Pending'
      if (status == 1) return 'Processing'
      if (status == 2) return 'Completed'
      if (status == 3) return 'Error'
      return 'Unknown'
    },
    statusColor(status) {
      if (status == 0) return 'secondary'
      if (status == 1) return 'warning'
      if (status == 2) return 'success'
      if (status == 3) return 'danger'
      return 'secondary'
    },
    
    // Details
    viewDetail(campaignId) {
      this.selectedCampaignId = campaignId;
      this.detailPage = 1;
      this.loadDetails();
      this.showDetailModal = true;
    },
    loadDetails() {
      axios.get(`/api/tool/zns-campaign/detail/${this.selectedCampaignId}?page=${this.detailPage}&limit=${this.detailPerPage}`).then(res => {
        this.details = res.data.data;
        this.detailTotalRows = res.data.total;
      })
    },
    detailPageChanged(page) {
      this.detailPage = page;
      this.loadDetails();
    },
    detailStatusText(status) {
      if (status == 0) return 'Pending'
      if (status == 1) return 'Sent'
      if (status == 2) return 'Error'
      return 'Unknown'
    },
    detailStatusColor(status) {
      if (status == 0) return 'secondary'
      if (status == 1) return 'success'
      if (status == 2) return 'danger'
      return 'secondary'
    }
  }
}
</script>
